import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8l10 8l-5 4l0 -16l5 4l-10 8","key":"svg-0"}]]

const IconBluetooth = createReactComponent('outline', 'bluetooth', 'Bluetooth', __iconNode);

export default IconBluetooth;